import { proxy } from 'valtio';
import {
	ApplicationsFilter,
	CandidateScreeningProgressSummaryFilter,
	CandidateScreeningProgressSummaryResponse,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';

export const DashboardListState = proxy<{
	filterBy: ApplicationsFilter | undefined;
	paging: PagingConfig;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
});

export const ScreeningDashboardState = proxy<{
	adminDashboardResponse: CandidateScreeningProgressSummaryResponse | undefined;
	dashboardFilter: CandidateScreeningProgressSummaryFilter;
}>({
	adminDashboardResponse: undefined,
	dashboardFilter: {},
});
